import { ServerAxiosRequestData } from '@config/axios';
import { ProductFeedQueryKeys } from '@enums/react-query-keys';
import { ProductFeedSource } from '@interfaces/api/payloads/product-feed-payload';
import { getSeasUserHeaders } from '@helpers/utils/catalog/catalog-tracking-utils';
import ProductFeedService from '@services/product-feed-service';
import { Preferences } from '@interfaces/models/preferences';

// this stuff encapsulates all the logic of query fetching so no need to duplicate query keys and frontend, SSR implementations
interface SimilarItemsFeed {
  productID: number;
  source: ProductFeedSource;
}

const getPaginationLimit = (source: ProductFeedSource) => {
  if (source == ProductFeedSource.HeroPDP) {
    return 40;
  }

  return 20;
};

export const getSEMPDPFeedQuery = (
  preferences: Preferences,
  userID: string,
  { productID, source }: SimilarItemsFeed,
  serverAnonymousID?: string,
  serverAxiosRequestData?: ServerAxiosRequestData,
) => {
  return {
    queryKey: [ProductFeedQueryKeys.SEM_FEED],
    staleTime: Infinity,
    queryFn: async () => {
      const payload = {
        productID: productID,
        locale: { country: preferences.country, language: preferences.language, currency: preferences.currency },
        pagination: { limit: getPaginationLimit(source), offset: 0 },
        options: { disableSizeFilter: true },
        source: source,
      };
      const headers = getSeasUserHeaders(userID, serverAnonymousID);

      return ProductFeedService.getSingleProductFeed(payload, headers, 'similar_products', serverAxiosRequestData);
    },
  };
};
